import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";

import { useOrganization } from "@/auth/organization";
import { Card, EmptyState, ErrorState, FullPageSpinner, PageHeader } from "@/components/ui";
import { formatDate } from "@/lib/format";
import { legal } from "@/lib/legal";

/** The policies currently in force, to read again at any time. */
export function PoliciesPage() {
  const { orgId } = useOrganization();
  const policies = useQuery({
    queryKey: ["legal", "policies", orgId],
    queryFn: () => legal.policies(orgId),
  });

  if (policies.isPending) return <FullPageSpinner />;
  if (policies.isError) return <ErrorState error={policies.error} onRetry={() => void policies.refetch()} />;
  const items = policies.data.policies;
  return (
    <div>
      <PageHeader
        title="Policies"
        description="The terms and policies that apply to your use of CortexGrip."
      />
      {items.length === 0 ? (
        <EmptyState title="No policies yet" description="Policies we publish will appear here." />
      ) : (
        <Card>
          <ul className="divide-y divide-border">
            {items.map((p) => (
              <li key={p.version_id}>
                <Link
                  to={`/policies/${encodeURIComponent(p.version_id)}`}
                  className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 px-4 py-3 hover:bg-muted"
                >
                  <span className="font-medium text-fg">{p.title}</span>
                  <span className="text-sm text-fg-muted">
                    v{p.version_number} · Published {formatDate(p.published_at)}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </Card>
      )}
    </div>
  );
}
